import React from 'react';
import './footer.css';

function Footer() {
    return (
        <div className="footer__container">
            <p>&copy; INFO 340 SPRING 2021 TEAM 5</p>
        </div>
    )
}
export default Footer;